import { useQuery } from "react-query";
import { getClasses } from "../services/school/class/getClasses";
import { PagedRequestType } from "../types/PagedResults";
import { Key_classes } from "../utils/constants";

export const useGetClassesQuery = (data: PagedRequestType, options: any =null) =>
  useQuery(
    [Key_classes, JSON.stringify(data)],
    () => getClasses(data), 
    options?{...options}:{}
  );